import { useSelector } from "react-redux";
import { Box, Grid, Typography, makeStyles } from "@material-ui/core";

import { XAxisTop } from "./XAxisTop";
import { XAxisBottom } from "./XAxisBottom";
import { COLORS } from "../../../../theme/colors";
import { currencyFormatter } from "../../../../services";
import { Icon } from "../../../../components/base";
import NPVIcon from "../../../../assets/images/noi/npv.svg";
import NOIIcon from "../../../../assets/images/noi/noi.svg";
import ROIIcon from "../../../../assets/images/noi/roi.svg";
import { PortfolioBarChart } from "../../../../components/charts";
import BuildinValueIcon from "../../../../assets/images/noi/building-value.svg";

const bars = [
  {
    dataKey: "before",
    fill: COLORS.purple,
  },
  {
    dataKey: "revised",
    fill: COLORS.viking,
  },
];

const useStyles = makeStyles(() => ({
  iconTitle: {
    marginLeft: 10,
  },
  iconBlock: {
    height: 40,
    marginBottom: 10,
  },
  items: {
    marginTop: "50px",
  },
}));

export const PortfolioFinanceOutcomes = ({ data }) => {
  const classes = useStyles();
  const currencySymbol = useSelector((state) => state.auth.user.currency.symbol);

  const getLabels = (chartData) => {
    const { data, unit } = chartData;
    return data.map((item, i) => {
      const value = "before" in item ? item.before : item.revised;
      return {
        color: i ? COLORS.viking : COLORS.purple,
        value: value
          ? unit === currencySymbol
            ? currencyFormatter(value, currencySymbol)
            : `${value.toString().replace(/\.00$/, "")}%`
          : null,
      };
    });
  };

  return (
    <Box>
      <Typography variant="h4" style={{ marginBottom: 50 }}>
        Valuation Parameters
      </Typography>
      <Grid container spacing={10}>
        <Grid item sm={6} xs={12}>
          <Grid container alignItems="center" className={classes.iconBlock}>
            <Icon src={NPVIcon} />
            <Typography variant="h4" className={classes.iconTitle}>
              NPV
            </Typography>
          </Grid>
          <XAxisTop labels={getLabels(data[0])} />
          <PortfolioBarChart chartData={data[0]} bars={bars} barSize={22} />
          <XAxisBottom labels={["Now", "Revised"]} />
        </Grid>
        <Grid item sm={6} xs={12}>
          <Grid container alignItems="center" className={classes.iconBlock}>
            <Icon src={NOIIcon} />
            <Typography variant="h4" className={classes.iconTitle}>
              NOI
            </Typography>
          </Grid>
          <XAxisTop labels={getLabels(data[1])} />
          <PortfolioBarChart chartData={data[1]} bars={bars} barSize={22} />
          <XAxisBottom labels={["Now", "Revised"]} />
        </Grid>
      </Grid>
      <Grid container spacing={10}>
        <Grid item sm={6} xs={12} className={classes.items}>
          <Grid container alignItems="center" className={classes.iconBlock}>
            <Icon src={ROIIcon} />
            <Typography variant="h4" className={classes.iconTitle}>
              ROI
            </Typography>
          </Grid>
          <XAxisTop labels={getLabels(data[2])} />
          <PortfolioBarChart chartData={data[2]} bars={bars} barSize={22} />
          <XAxisBottom labels={["Now", "Revised"]} />
        </Grid>
        <Grid item sm={6} xs={12} className={classes.items}>
          <Grid container alignItems="center" className={classes.iconBlock}>
            <Icon src={BuildinValueIcon} />
            <Typography variant="h4" className={classes.iconTitle}>
              Buildings Value
            </Typography>
          </Grid>
          <XAxisTop labels={getLabels(data[3])} />
          <PortfolioBarChart chartData={data[3]} bars={bars} barSize={22} />
          <XAxisBottom labels={["Now", "Revised"]} />
        </Grid>
      </Grid>
    </Box>
  );
};
